import i18n from '.';

/* Formats de nombres et de dates qui suivent la langue de l'interface.

   A appeler au moment de formater, jamais au chargement d'un module : une valeur
   calculee une fois pour toutes garderait la langue du demarrage.

   Ne pas utiliser pour un document adresse a un tiers (lettre, attestation,
   offre) : sa langue est celle du destinataire, pas celle de l'agent. */

const LOCALE_INTL = { fr: 'fr-FR', en: 'en-GB' };

/** 'fr-FR' ou 'en-GB', pour Intl.NumberFormat, toLocaleString, toLocaleDateString... */
export const localeIntl = () => LOCALE_INTL[i18n.language] || LOCALE_INTL.fr;
